module.exports = __webpack_public_path__ + "img/community-messages.98d6bfa6.png";